/** Las cinco preguntas del brief, con icono por tipo y en rejilla.
 *  Forma tomada de la referencia del cliente: icono en pastilla de acento, título en negrita y
 *  una línea de descripción. La complejidad va como etiqueta discreta, porque es del brief. */
import type { Idioma, Sugerencia } from "../lib/tipos";
import { t } from "../lib/i18n";

const ICONO: Record<string, string> = { q1: "◫", q2: "▦", q3: "◠", q4: "≡", q5: "◍" };
const TITULO: Record<string, { es: string; en: string }> = {
  q1: { es: "Comparar especificaciones", en: "Compare specifications" },
  q2: { es: "Fuera de especificación y percepción", en: "Out-of-spec and perception" },
  q3: { es: "Calidad, ME% e impacto", en: "Quality, ME% and impact" },
  q4: { es: "Resumen de 12 meses", en: "12-month summary" },
  q5: { es: "Ciclo de vida y claims", en: "Life cycle and claims" },
};

export function Sugerencias({ sugerencias, idioma, alElegir }: {
  sugerencias: Sugerencia[]; idioma: Idioma; alElegir: (texto: string) => void;
}) {
  const txt = t(idioma);
  if (!sugerencias.length) return null;
  return (
    <section className="sugerencias">
      <h2>{txt.sugerencias}</h2>
      <div className="rejilla-sugerencias">
        {sugerencias.map((s) => (
          <button key={s.id} onClick={() => alElegir(s[idioma])}>
            <span className="sug-icono" aria-hidden="true">{ICONO[s.id] ?? "◇"}</span>
            <span className="sug-texto">
              <strong>{TITULO[s.id]?.[idioma] ?? s.id}</strong>
              <span className="sug-desc">{s[idioma]}</span>
            </span>
            <span className="sug-complejidad">{s.complejidad}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
